import * as Avatar from "@radix-ui/react-avatar";
import logo_tlp from "../assets/logo_tlp.svg";
import useStore from "../store/useStore";
// import { ModeToggle } from "./mode-toggle";
import { Logout } from "./Logout";
//import { CheckboxDropdown } from "./CheckBoxDropdown";

// Array de cores para o avatar
const avatarColors = [
  "bg-blue-500",
  "bg-green-500",
  "bg-yellow-500",
  "bg-red-500",
  "bg-purple-500",
  "bg-pink-500",
  "bg-indigo-500",
  "bg-orange-500",
];

// Função para pegar as iniciais do nome
const getInitials = (fullName: string) => {
  if (!fullName) return "??";
  const names = fullName.trim().split(" ");
  const firstName = names[0];
  const lastName = names[names.length - 1];
  return `${firstName[0]}${lastName[0]}`.toUpperCase();
};

// Função para gerar uma cor aleatória consistente baseada no nome
const getColorForName = (name: string) => {
  if (!name) return avatarColors[0];
  const index = name
    .trim()
    .split(" ")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return avatarColors[index % avatarColors.length];
};

export function Header() {
  const { user } = useStore((state) => state);
  const avatarColor = getColorForName(user.nome);
  return (
    <div className="w-full dark:bg-gray-600 bg-slate-200 h-14 flex items-center justify-between">
      <div className="flex justify-start dark:bg-gray-600 bg-slate-200 pl-6">
        <img src={logo_tlp} alt="Logo" className="h-9 w-auto" />
        <div
          className="flex items-end font-tomorrow font-extrabold italic text-[#666666] text-xl 
          mb-[-6px] ml-[-6px]"
        >
          Radar
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-4 pr-6">
          <Avatar.Root className="h-9 w-9 flex items-center">
            <Avatar.Fallback
              className={`h-full w-full rounded-full ${avatarColor} text-white flex items-center justify-center font-semibold`}
            >
              {getInitials(user.nome)}
            </Avatar.Fallback>
          </Avatar.Root>
          {user.nome}
          <Logout />
          {/* <ModeToggle /> */}
        </div>
      </div>
    </div>
  );
}
